import { z } from "zod"

export const farmSchema = z.object({
	farmName: z.string().min(1, { message: "Farm Name is Required" }),
	farmType: z.string().min(1, { message: "Farm Type is Required" }),
	ownerName: z.string().min(1, { message: "Owner Name is Required" }),
	phoneNumber: z
			.string()
			.min(10, { message: "Phone Number must be at least 10 digits" }),
	email: z.string().email({ message: "Valid Email is Required" }),
	status: z.string().min(1, { message: "Status is Required" }),
	country: z.string().min(1, { message: "Country is Required" }),
	state: z.string().min(1, { message: "State is Required" }),
	city: z.string().min(1, { message: "City is Required" }),
	zipCode: z.string().optional().or(z.literal("")),
	address: z.string().optional().or(z.literal("")),
});

export type TFarm = z.infer<typeof farmSchema>;
